import { NgModule } from "@angular/core";
import { BROWSER_GLOBALS_PROVIDERS, DocumentRef, WindowRef } from "./browser-globals";
import { LocalStoreService } from "./local-store.service";

@NgModule({})

class UtilsModule {
}

export {
    UtilsModule,
    BROWSER_GLOBALS_PROVIDERS,
    DocumentRef,
    WindowRef,
    LocalStoreService
};
